import React from "react";
import { Box } from "@mui/material";
import { colors } from "src/config/colors";

const ASSUMED_PIC = new Set(["approx", "brand_form", "brand_digits"]);

export const photoIsAssumed = (picMatch?: string | null) =>
  !!picMatch && ASSUMED_PIC.has(picMatch);

const Noindex: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <>
    <span dangerouslySetInnerHTML={{ __html: "<!--noindex-->" }} />
    {children}
    <span dangerouslySetInnerHTML={{ __html: "<!--/noindex-->" }} />
  </>
);

const SHORT_PHOTO =
  "Внешний вид товара может отличаться от изображенного на фото";

const LONG_PHOTO =
  "Фотография носит ознакомительный характер. Дозировка, количество или производитель на изображении могут отличаться. Актуальные характеристики указаны в текстовом описании товара выше.";

export const PhotoCaption: React.FC<{ picMatch?: string | null }> = ({
  picMatch,
}) => {
  if (!photoIsAssumed(picMatch)) {
    return (
      <Box
        textAlign="center"
        sx={{
          mt: 1,
          mb: 2,
          fontSize: { xs: "13px", md: "13px" },
          lineHeight: "16px",
          color: colors.gray3,
          px: 1,
        }}
      >
        {SHORT_PHOTO}
      </Box>
    );
  }
  return (
    <Noindex>
      <Box
        textAlign="center"
        sx={{
          mt: 1,
          mb: 2,
          fontSize: "13px",
          lineHeight: "18px",
          color: colors.gray3,
          px: 1,
        }}
      >
        <strong>Обратите внимание:</strong> {LONG_PHOTO}
      </Box>
    </Noindex>
  );
};

export const InstructionDisclaimer: React.FC = () => (
  <Noindex>
    <Box
      sx={{
        backgroundColor: "#fff9e6",
        borderLeft: "4px solid #ffcc00",
        padding: "10px",
        marginX: { xs: "16px", lg: "24px" },
        marginBottom: "15px",
        fontSize: "14px",
        lineHeight: "20px",
        color: "#333",
      }}
    >
      <strong>Обратите внимание:</strong> Информация о препарате носит
      справочный характер. Конкретная дозировка, форма выпуска и производитель
      могут отличаться от представленных в этой инструкции. Перед применением
      проконсультируйтесь со специалистом. Полная официальная инструкция
      находится внутри упаковки товара.
    </Box>
  </Noindex>
);

export const RlsSourceNote: React.FC = () => (
  <Box
    component="p"
    sx={{
      marginTop: "20px",
      marginX: { xs: "16px", lg: "24px" },
      marginBottom: "8px",
      fontSize: "13px",
      lineHeight: "18px",
      color: "#666",
    }}
  >
    Инструкция подготовлена на основе данных{" "}
    <a
      href="https://www.rlsnet.ru/"
      target="_blank"
      rel="noopener noreferrer"
    >
      Электронной энциклопедии лекарств РЛС
    </a>
    .
  </Box>
);
